import initialstate from '../../initialstate';
import {
	GET_INSTRUCTIONS,
	POST_INSTRUCTIONS,
	POST_NEW_SECTION,
	UPDATE_INSTRUCTIONS,
	PATCH_SECTIONS,
	DELETE_INSTRUCTION,
	DELETE_CUSTOM_SECTION,
	DELETE_DOCUMENT_BY_ID,
	GET_ALL_RELATED_DOCUMENTS_FOR_BODIES
} from '../../../actions/actiontypes';
import normalizeSections from './normalizeSections';
import addNewInstruction from './addNewInstruction';
import editSectionName from './editSectionName';
import {HttpStatusCodes, documentTypes} from '../../../util/uiconstants';
import updateInstruction from './updateInstruction';
import deleteInstruction from './deleteInstruction';
import deleteSection from './deleteSection';
import mergeSections from './mergeSections';
import orderInstructions from './orderInstructions';
import getDocumentsCount from './getDocumentsCount';

export default function groupInstructionsReducer(state = initialstate.groupAudit.sections, action) {
	switch (action.type) {
		case GET_INSTRUCTIONS: {
			if (action?.response.length === 0) return [];
			const newSection = normalizeSections(action?.response);
			const mergedSections = mergeSections(newSection, state);
			const orderedInstructions = orderInstructions(mergedSections);
			return orderedInstructions;
		}
		case POST_INSTRUCTIONS: {
			if (action.response && action.responseObj.status === HttpStatusCodes.Created) {
				let newInstructionsList = addNewInstruction(state, action.response.instructions);
				return newInstructionsList;
			}
			return state;
		}
		case PATCH_SECTIONS: {
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				const newEditSection = editSectionName(state, action.response.id, action.response.groupSectionName);
				return newEditSection;
			}
			return state;
		}
		case DELETE_DOCUMENT_BY_ID: {
			if (action.responseObj.status === HttpStatusCodes.Ok && action.meta.instructionId !== null) {
				const newState = JSON.parse(JSON.stringify(state));
				// Find the section and instruction to modify
				newState.forEach((section) => {
					section.instructions.forEach((instruction) => {
						if (instruction.id === action.meta.instructionId) {
							// Filter out the specified document
							instruction.documents = instruction.documents.filter((doc) => doc.documentId !== action.documentId);
							instruction.documentsCount = getDocumentsCount(instruction.documents);
						}
					});
				});
				return newState;
			}
			return state;
		}
		case UPDATE_INSTRUCTIONS: {
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				let instructionsListUpdated = updateInstruction(state, action.response);
				return instructionsListUpdated;
			}
			return state;
		}
		case DELETE_INSTRUCTION: {
			if (action.responseObj.status === HttpStatusCodes.NoContent) {
				return deleteInstruction(state, action.instructionId);
			}
			return state;
		}
		case POST_NEW_SECTION: {
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				const newSection = {
					id: action.response?.id,
					sectionName: action.response?.groupSectionName,
					isCustom: action.response?.isCustom,
					knowledgeInstructionSectionId: action.response?.knowledgeInstructionSectionId,
					instructions: []
				};
				return [...state, newSection];
			}
			return state;
		}
		case DELETE_CUSTOM_SECTION: {
			if (action.responseObj.status === HttpStatusCodes.NoContent) {
				return deleteSection(state, action.sectionId);
			}
			return state;
		}
		case GET_ALL_RELATED_DOCUMENTS_FOR_BODIES: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok && action?.meta?.entityUID !== undefined) {
				const newState = state?.map((section) => ({
					...section,
					instructions: section?.instructions?.map((instruction) => {
						if (instruction.id === action.meta.entityUID) {
							const updatedDocuments = [...instruction.documents];

							action?.response?.data
								?.filter((newDocument) => newDocument.documentTypeId === documentTypes.evidence)
								.forEach((newDocument) => {
									const documentExists = updatedDocuments?.some((document) => document?.documentId === newDocument.id || document?.id === newDocument.id);

									if (!documentExists) {
										updatedDocuments.push(newDocument);
									}
								});

							return {
								...instruction,
								documents: updatedDocuments,
								documentsCount: getDocumentsCount(updatedDocuments)
							};
						}
						return instruction;
					})
				}));
				return newState;
			}
			return state;
		}
		default:
			return state;
	}
}
